<div class="bg-gray entity-filter" [ngClass]="{
    'desktop-filters': media.isActive('gt-sm'),
    'mobile-filters': !media.isActive('gt-sm') }" fxFlex>
    <div id="filters" fxLayout="column" fxFlex class="bg-gray">

        <!-- Toolbar -->
        <sfx-toolbar [disableBack]="true" *ngIf="!hideToolbar && (!fixedFilters || !media.isActive('gt-sm'))"
            class="avatar hide-on-non-dialog filters-toolbar">
            <div class="md-toolbar-tools">
                <button style="margin-left: 4px; margin-right: 4px;" mat-icon-button (click)="toggleMenu()">
                    <mat-icon fontSet="salesflare" fontIcon="sf-icon-close" class="icon-24"></mat-icon>
                </button>
                <h1 translate>Filters</h1>
            </div>
        </sfx-toolbar>
        <mat-divider *ngIf="!hideToolbar && !fixedFilters" class="hide-in-dialog"></mat-divider>

        <!-- Saved Filters -->
        <div *ngIf="savedFiltersEnabled()" class="saved-filters">
            <div class="saved-filters-header">
                <div class="md-subheader filter-header" [ngClass]="{ 'mobile-filter-header': !media.isActive('gt-sm') }">
                    <span translate>Saved filters</span>
                </div>
                <button mat-button *ngIf="savedFilters.length > 0" class="manage-saved-filters"
                    (click)="manageSavedFilters()">
                    <span translate>Manage</span>
                </button>
            </div>

            <div *ngIf="savedFilters.length === 0" class="saved-filter-empty-state">
                {{ getNoSavedFiltersMessage() }}
            </div>

            <div *ngIf="savedFilters.length > 0" class="saved-filters-select-container">
                <mat-form-field appearance="fill" style="width: 100%">
                    <mat-select [value]="savedFilterMdSelectModel"
                        (selectionChange)="onSelectSavedFilter($event.value)">
                        <mat-select-trigger>
                            {{ getSavedFilterName() }}
                        </mat-select-trigger>

                        <mat-option [value]="0">
                            <span translate>Default</span>
                            <span
                                *ngIf="isSavedFilterDirty && !savedFilterMdSelectModel && !appliedSavedFilter">*</span>
                        </mat-option>

                        <mat-option *ngFor="let savedFilter of savedFilters" [value]="savedFilter.id">
                            {{ savedFilter.name }} {{ isSavedFilterDirty && appliedSavedFilter?.id === savedFilter.id ?
                            '*' : '' }}
                        </mat-option>

                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <!-- Filter Groups -->
        <div *ngFor="let filterGroup of filterGroups">
            <div class="md-subheader filter-header" [ngClass]="{ 'mobile-filter-header': !media.isActive('gt-sm') }">
                <span fxFlex>{{ filterHeaderText }}</span>
            </div>

            <!-- Bad Filter Info -->
            <div *ngIf="showBadFilterInfo" class="filter-header entity-filter_bad-filter-info" fxLayout="row">
                <mat-icon fontSet="salesflare" fontIcon="sf-icon-info" aria-label="Information" role="img"
                    class="icon-16 entity-filter_bad-filter-info_info-icon"></mat-icon>
                <span class="entity-filter_bad-filter-info_info-text">
                    {{ faultyFilterRules.firstLine }}
                    {{ faultyFilterRules.secondLine }}
                </span>
            </div>

            <!-- Filter Group Component -->
            <sfx-filters-group [fixedFilters]="fixedFilters" [entity]="entity" [group]="group"
                [index]="filterGroup.index" [appliedGroup]="filterGroups[filterGroup.index]"
                [filterFields]="filterFields" [deleteGroup]="getRemoveFilterGroupFn(filterGroup.index)"
                [onFilterUpdate]="boundUpdateFilterGroup" [onApply]="boundApplyFilters">
            </sfx-filters-group>
        </div>

        <!-- Actions -->
        <div class="btn-group filter-actions">
            <button mat-button class="filter-btn" (click)="resetFilterGroups()"
                [disabled]="savedFiltersEnabled() && !isSavedFilterDirty">
                <span translate>Reset</span>
            </button>

            <button mat-button *ngIf="savedFiltersEnabled()" class="filter-btn" (click)="saveFilter()"
                [disabled]="!isSavedFilterDirty">
                <span translate>Save</span>
            </button>
        </div>

    </div>
</div>